export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/Close.fab64928.svg","height":20,"width":20};